module.exports = __webpack_public_path__ + "img/key-fill.ce22c083.svg";